import Vue from 'vue';

const globals = Vue.observable({
  overlay: false,
});

Object.defineProperty(Vue.prototype, '$overlay', {
  get() { return globals.overlay; },
  set(value) { globals.overlay = !!value; },
});

Object.defineProperty(Vue.prototype, '$tema', {
  get() { return '#20B1AC'; },
});

Object.defineProperty(Vue.prototype, '$corTextoPrimary', {
  get() { return '#FFFFFF'; },
});
